import React from 'react';
import Linkify from 'react-linkify';
import classnames from 'classnames/bind';

import styles from './commentStyles';

import AnonEmployerAssociation from 'buyside/components/presentation/EmployerAssociation/anonEmployerAssociation';
import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';
import CommentBodyRenderer from 'buyside/components/presentation/CommentBodyRenderer/commentBodyRenderer';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Like from 'buyside/components/presentation/Feed/Actions/like';
import Link from 'buyside/components/presentation/Link/link';
import EmployerAssociation from 'buyside/components/presentation/EmployerAssociation/employerAssociation';
import PostCommentForm from 'buyside/components/presentation/PostShow/postCommentForm';
import CommentContainer from 'buyside/components/container/CommentContainer';

import { userUrl } from 'buyside/util/urlHelper';
import { truncateAroundWords } from 'buyside/util/textHelpers';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply } from '@fortawesome/free-solid-svg-icons/faReply';

const cx = classnames.bind(styles);

class Comment extends React.Component {
  constructor(props) {
    super(props);
    this.state = { commentExpanded: false, showChildComments: true, showReplyForm: false };
    this.handleExpandComment = this.handleExpandComment.bind(this);
  }

  handleExpandComment() {
    this.setState({ commentExpanded: !this.state.commentExpanded });
  }

  renderBody() {
    const body = this.props.comment.body;
    if (body.length > 500) {
      let bodyText = truncateAroundWords(body, 400);
      let buttonText = 'show more';
      if (this.state.commentExpanded) {
        bodyText = body;
        buttonText = 'show less';
      }
      return (
        <div>
          <div>
            <CommentBodyRenderer body={bodyText} />
          </div>
          <Button
            onClick={this.handleExpandComment}
            type={BUTTON_TYPES.LINK}
            text={buttonText}
            size={BUTTON_SIZES.SMALL}
          />
        </div>
      );
    } else {
      return <CommentBodyRenderer body={body} />;
    }
  }

  render() {
    const {
      allComments,
      canCommentAnonymously,
      childComments,
      comment,
      feedItemId,
      isAllocator,
      mentionables,
      postId,
      profileImageUrl,
      showLikes
    } = this.props;
    const { showReplyForm, showChildComments } = this.state;
    const currentUserHasLiked = comment.currentUserHasLiked;

    let user, userDisplay;

    const likeTextClass = cx({
      likeArea: true,
      green: currentUserHasLiked
    });

    if (comment.user) {
      user = comment.user;
      const mostRecentEmployer = user.mostRecentEmployer;
      userDisplay = (
        <>
          {comment.byAllocator ? (
            <strong>{user.displayName}</strong>
          ) : (
            <Link to={userUrl(user.id)}>{user.displayName}</Link>
          )}
          <EmployerAssociation
            mostRecentEmployer={mostRecentEmployer}
            style={styles.userEmployment}
          />
        </>
      );
    } else if (comment.anonUser) {
      user = comment.anonUser;
      userDisplay = (
        <>
          <strong>
            <AnonymousUserDisplay anonUser={user} />
          </strong>
          <AnonEmployerAssociation
            aumRange={user.aumRange}
            fundType={user.fundType}
            employerStyles={styles.userEmployment}
          />
        </>
      );
    }

    const likeCount = comment.likeCount > 0 ? `(${comment.likeCount})` : '';

    return (
      <div className={styles.comment} data-heap-segment="activity-feed-comment">
        <ProfileImage source={user.profileImageUrl} size="tiny" style={styles.commentImage} />
        <div className={styles.commentContent}>
          <h4 className={styles.heading}>
            <div className={styles.userDisplay}>
              <div>{userDisplay}</div>
              <div className={styles.timeAgo}>{comment.commentCreationTime} ago</div>
            </div>
          </h4>
          <Linkify properties={{ className: styles.commentLink, target: '_blank' }}>
            <div className={styles.commentBody}>{this.renderBody()}</div>
          </Linkify>
          <div className={styles.commentActionContainer}>
            {showLikes && (
              <div className={likeTextClass}>
                <Like
                  currentUserHasLiked={currentUserHasLiked}
                  styles={{ marginRight: '5px' }}
                  onClick={this.props.handleLike}
                />
                <span>{likeCount}</span>
              </div>
            )}
            <div
              className={styles.replyIconArea}
              onClick={() => this.setState({ showReplyForm: !showReplyForm })}
              id={`comment-${comment.id}-reply-button`}
            >
              <FontAwesomeIcon icon={faReply} className={styles.replyIcon} />
              <div className={styles.replyIconLabel}>Reply</div>
            </div>
          </div>
          {!comment.parentId && childComments.length > 0 && (
            <div className={styles.continueThreadArea}>
              <button
                onClick={() => this.setState({ showChildComments: !showChildComments })}
                className={styles.continueThreadItem}
              >
                {showChildComments ? 'Close Thread' : 'Continue Thread'}
              </button>
            </div>
          )}
          {showReplyForm && (
            <PostCommentForm
              canCommentAnonymously={canCommentAnonymously}
              closeFormOpenThread={() => {
                this.setState({ showChildComments: true, showReplyForm: false });
              }}
              closeForm={() => {
                this.setState({ showReplyForm: false });
              }}
              feedItemId={feedItemId}
              isAllocator={isAllocator}
              isChildComment
              mentionables={mentionables}
              parentId={comment.id}
              postId={postId}
              profileImageUrl={profileImageUrl}
            />
          )}
          <div className={styles.threadContainer}>
            {(comment.parentId || showChildComments) &&
              childComments.map(comment => (
                <CommentContainer
                  allComments={allComments}
                  canCommentAnonymously={canCommentAnonymously}
                  comment={comment}
                  feedItemId={feedItemId}
                  isAllocator={isAllocator}
                  key={comment.id}
                  mentionables={mentionables}
                  postId={postId}
                  profileImageUrl={profileImageUrl}
                  showLikes
                />
              ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Comment;
